import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faInstagram } from "@fortawesome/free-brands-svg-icons"

export const Instagram = (props) => {
  return <FontAwesomeIcon faIcon={faInstagram} {...props} />
}
